export default "__VITE_ASSET__xPMr9VvZ__"